var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear",
    transform: "translate(-484 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    width: 24,
    height: 24,
    transform: "translate(484 12)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M17.016-8.391,13.406-12l3.609-3.609-1.406-1.406L12-13.406,8.391-17.016,6.984-15.609,10.594-12,6.984-8.391,8.391-6.984,12-10.594l3.609,3.609ZM4.945-19.055A9.616,9.616,0,0,1,12-21.984a9.616,9.616,0,0,1,7.055,2.93A9.616,9.616,0,0,1,21.984-12a9.616,9.616,0,0,1-2.93,7.055A9.616,9.616,0,0,1,12-2.016a9.616,9.616,0,0,1-7.055-2.93A9.616,9.616,0,0,1,2.016-12,9.616,9.616,0,0,1,4.945-19.055Z",
    transform: "translate(484 36)",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.eb1b56af4dd0b739cbc8d1d451710164.svg";
export { ForwardRef as ReactComponent };